(ns nl.mediquest.questionnaire-frontend.core
  (:require
   [day8.re-frame.http-fx]
   [nl.mediquest.questionnaire-frontend.config :as config]
   [nl.mediquest.questionnaire-frontend.events :as events]
   [nl.mediquest.questionnaire-frontend.component.i18n :as i18n]
   [nl.mediquest.questionnaire-frontend.routes :as routes]
   [nl.mediquest.questionnaire-frontend.subs]
   [nl.mediquest.questionnaire-frontend.views :as views]
   [nl.mediquest.questionnaire-frontend.vitaliteitsscan :as vitaliteitsscan]
   [nl.mediquest.ui.css :refer [inject-styles! inject-stylesheet!]]
   [nl.mediquest.ui.fn]
   [re-frame.core :as re-frame]
   [reagent.dom.client :as dom-client]))

(defn dev-setup []
  (when config/debug?
    (println "dev mode")))

(defonce root
  (delay (dom-client/create-root (.getElementById js/document "app"))))

(defn ^:dev/after-load mount-root []
  (re-frame/clear-subscription-cache!)
  (i18n/init-url-param-locale)
  (dom-client/render @root [views/main-panel]))

(defn- setup []
  (re-frame/dispatch-sync [::events/initialize-db])
  (re-frame/dispatch-sync [::events/base-url])
  (dev-setup)
  (mount-root))

(defn ^:export init []
  (routes/app-routes)
  (if (and config/vitaliteitsscan? (not config/on-vitaliteitsscan?))
    (vitaliteitsscan/set-pathname) ; NOTE: reloads page, `setup` is reached after that
    (setup)))

(def default-styles
  {:--color-primary "#6e52b5"
   :--color-primary-alpha "110, 82, 181"
   :--color-primary-600 "#584190"
   :--color-primary-700 "#4c3b82"
   :--color-secondary "#f0ebff"
   :--color-footer "#2e3f52"})

(defn- inject-dom-content! []
  (inject-styles! :css.theme/styles [[":root" default-styles]])
  (inject-stylesheet! :css.theme/href "/css/fonts.css"))

(defonce _
  (js/document.addEventListener
   "DOMContentLoaded"
   (fn []
     (if config/vitaliteitsscan?
       (do
         (vitaliteitsscan/inject-dom-content!)
         (re-frame/dispatch [::events/set-available-locales [:nl :en]]))
       (inject-dom-content!)))))
